/**
 * Minha conta > Trocar senha, para quem esta logado (cliente do portal ou
 * equipe). Pede a senha atual; o servidor confere, troca e encerra as outras
 * sessoes, mantendo esta. As senhas so vivem no formulario, que esvazia.
 */
import { useState } from 'react';
import { useIdioma, type Chave } from '../i18n/index.tsx';
import { PaginaSecao } from '../layout/Shell.tsx';
import { useSessao } from '../sessao.tsx';
import './login.css';

const ERROS: Record<string, Chave> = {
  senha_atual_incorreta: 'conta.erro.atual',
  senha_curta: 'senha.erro.curta',
  senha_igual: 'conta.erro.igual',
  muitas_tentativas: 'conta.erro.muitas',
};

export function MinhaConta() {
  const { t } = useIdioma();
  const { estado } = useSessao();
  const [mensagem, setMensagem] = useState<{ ok: boolean; chave: Chave } | null>(null);
  const [enviando, setEnviando] = useState(false);
  const nome = estado.fase === 'dentro' ? estado.eu.usuario.nome : '';
  return <PaginaSecao kicker={nome} titulo={t('conta.titulo')}>
    <form className="cartao minha-conta" onSubmit={(e) => {
      e.preventDefault();
      const form = e.currentTarget;
      const d = new FormData(form);
      const atual = String(d.get('atual') ?? '');
      const nova = String(d.get('nova') ?? '');
      setMensagem(null);
      if (nova.length < 12) { setMensagem({ ok: false, chave: 'senha.erro.curta' }); return; }
      if (nova !== String(d.get('confirmar') ?? '')) {
        setMensagem({ ok: false, chave: 'senha.erro.diferentes' });
        return;
      }
      setEnviando(true);
      void fetch('/api/v1/auth/trocar-senha', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ senha_atual: atual, senha_nova: nova }),
      }).then(async (r) => {
        if (r.ok) {
          form.reset();
          setMensagem({ ok: true, chave: 'conta.ok' });
          return;
        }
        const corpo = await r.json().catch(() => ({})) as { code?: string };
        setMensagem({ ok: false, chave: ERROS[corpo.code ?? ''] ?? 'senha.erro.generico' });
      }).catch(() => setMensagem({ ok: false, chave: 'senha.erro.generico' }))
        .finally(() => setEnviando(false));
    }}>
      <h2 className="minha-conta__titulo">{t('conta.trocar')}</h2>
      <label className="campo">
        <span className="campo__rotulo">{t('conta.atual')}</span>
        <input className="campo__entrada" type="password" name="atual"
          autoComplete="current-password" required maxLength={200} />
      </label>
      <label className="campo">
        <span className="campo__rotulo">{t('senha.campo')}</span>
        <input className="campo__entrada" type="password" name="nova" autoComplete="new-password"
          required minLength={12} maxLength={200} aria-describedby="conta-regra" />
        <span id="conta-regra" className="campo__rotulo">{t('senha.regra')}</span>
      </label>
      <label className="campo">
        <span className="campo__rotulo">{t('senha.confirmar')}</span>
        <input className="campo__entrada" type="password" name="confirmar"
          autoComplete="new-password" required minLength={12} maxLength={200} />
      </label>
      {mensagem !== null && <p role={mensagem.ok ? 'status' : 'alert'}
        className={mensagem.ok ? 'minha-conta__ok' : 'login__erro'}>{t(mensagem.chave)}</p>}
      <button className="botao botao--primario" type="submit" disabled={enviando}>
        {t('conta.trocar')}</button>
    </form>
  </PaginaSecao>;
}
